module.exports = __webpack_public_path__ + "img/logoLiberdade.c67259e3.png";